import axios from 'axios';
// ---- external imports -----

import { getBaseUrl } from '../lib/helpers';
import { WAREHOUSE_APIS } from '../endpoints';
// ---- parent imports -----

import { getRequestHeaders } from './headers';
import { formatResponse } from './utlis';
import ApiService from './axiosInterceptor.service';
// ---- local imports -----

class WarehousesService {
	async fetchAllWarehouses() {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/${WAREHOUSE_APIS.GET_ALL}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}

	async fetchLeasedWarehouses(gameUserId) {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${WAREHOUSE_APIS.LEASED_LIST}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}
	
	async leaseWarehouse(gameUserId, id) {
		const data = { warehouse: id };
		
		const response = await ApiService.request({
			method: 'POST',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${WAREHOUSE_APIS.LEASE}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}

	async unleaseWarehouse(gameUserId, leasedWarehouseId) {
		const data = { leasedWarehouseId };
		
		const response = await ApiService.request({
			method: 'POST',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${WAREHOUSE_APIS.UNLEASE}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}
}

export default new WarehousesService();
